import React, { useEffect } from 'react';

const WebSocketComponent = () => {
  useEffect(() => {
    const ws = new WebSocket('ws://localhost:3002');

    ws.onopen = () => {
      console.log('WebSocket Client Connected');
      ws.send('Hi this is web client.');
    };

    ws.onmessage = (message) => {
      console.log('Received: ' + message.data);
    };

    ws.onerror = (error) => {
      console.error('WebSocket Error: ', error);
    };

    ws.onclose = () => {
      console.log('WebSocket Client Disconnected');
    };

    return () => {
      ws.close();
    };
  }, []);

  return <div>WebSocket Component</div>;
};

export default WebSocketComponent;
